
import { Observer } from 'mobx-vue'
import { Component, Mixins } from 'vue-property-decorator'
import { MixinsMyAllCourse } from '@xt/client/mixins'
import ShowPopup from '../../../../../components/showPopup/showPopup.vue'
import LazyImg from '@/components/lazyImg/index.vue'

@Observer
@Component({
  components: {
    ShowPopup,
    LazyImg
  }
})
export default class Page extends Mixins(MixinsMyAllCourse) {
  showPopVisible: boolean = false

  get showUrl() {
    return 'https://file.xuantong.cn/images/origin/98558c34fce77c259460228f038a630f.jpeg'
  }

  jumpPage() {
    if (this.isCourse) {
      this.$router.push({
        name: 'course-id',
        params: { id: this.dataSource.bizId }
      })
    } else if (this.isDay) {
      // 页面已经被删除，直接拉起弹窗
      this.$emit('show-course-pop', { type: 'activity', id: this.dataSource.bizId })
    } else {
      // 页面已经被删除，直接拉起弹窗
      // 需要区分是观展阶段 还是备展阶段
      const now = this.$ajax.serviceDate()
      this.$emit('show-course-pop', {
        type: now.isBefore(this.dataSource.voteStartTime) ? 'show-prepare' : 'show-looking',
        id: this.dataSource.bizId
      })
    }
  }
}
